import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { controlSize } from "../../../design-system/tokens/controlSizes";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { FieldLabel, FieldRoot, HelperText, RequiredMark } from "../FormField/FormField.styles";

export { FieldRoot, FieldLabel, HelperText, RequiredMark };

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FileButton = styled.button<{ $invalid?: boolean }>`
  width: 100%;
  height: ${controlSize.configForm.controlHeight};
  box-sizing: border-box;
  border-radius: ${borderRadius.lg};
  border: 1px solid
    ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.stroke[200]};
  background-color: #FAFAFC;
  color: ${rawColors.text.lowEmphasis};
  ${typographyMixin("body", 3)}
  padding: 0 ${spacing[3]};
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled):not(:focus-visible) {
    border-color: ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.stroke[300]};
  }

  &:focus-visible {
    outline: none;
    border-color: ${({ $invalid }) =>
      $invalid ? rawColors.accent.red500 : rawColors.primary[500]};
  }
`;
